import type { QueueJobStatus, QueueStatsDto } from '@carvia/ros-client-types';
import { Service } from './http-service';
import type { JobDto } from '@carvia/ros-client-types';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';

class QueueInspectorService extends Service {
  constructor() {
    super('/queue-inspector');
  }

  async getAvailableQueues(): Promise<string[]> {
    const res = await this.httpClient.get<string[]>(`${this.endpoint}/queues`);
    return res.data;
  }

  async getQueueStats(queueName: string): Promise<QueueStatsDto> {
    const res = await this.httpClient.get<QueueStatsDto>(
      `${this.endpoint}/queues/${queueName}/stats`,
    );
    return res.data;
  }

  async getQueueJobs(
    queueName: string,
    statuses: QueueJobStatus[],
    page: number = 1,
    limit: number = 10,
  ): Promise<PaginatedResponse<JobDto>> {
    const res = await this.httpClient.get<PaginatedResponse<JobDto>>(
      `${this.endpoint}/queues/${queueName}/jobs`,
      {
        params: {
          status: statuses,
          page,
          limit,
        },
      },
    );
    return res.data;
  }

  async getJobLogs(queueName: string, jobId: string): Promise<string[]> {
    const res = await this.httpClient.get<string[]>(
      `${this.endpoint}/queues/${queueName}/jobs/${jobId}/logs`,
    );
    return res.data;
  }

  async retryJob(queueName: string, jobId: string): Promise<void> {
    await this.httpClient.post(`${this.endpoint}/queues/${queueName}/jobs/${jobId}/retry`);
  }

  async deleteJob(queueName: string, jobId: string): Promise<void> {
    await this.httpClient.delete(`${this.endpoint}/queues/${queueName}/jobs/${jobId}`);
  }
}

export const queueInspectorService = new QueueInspectorService();
